import classNames from "classnames";
import React, { useMemo } from "react";
import { useWowPath } from "../../hooks/path-hooks";
import { NavLink, useLocation } from "react-router-dom";
import { useQueryString } from "../../hooks/general-hooks";

const BuildsTabNav = () => {
  const { encounterType: buildType, page } = useWowPath();

  return (
    <div className="page-nav-container">
      <div className="nav_tabs-list">
        <NavTab page="talents" label="Talents" selected={page === "talents"} />
        <NavTab page="gear" label="Gear" selected={page === "gear"} />
        <NavTab page="gems-and-enchants" label="Enchants & Gems" selected={page === "gems-and-enchants"} />
        <NavTab page="builds" label="Builds" selected={page === "builds"} />
        <NavTab page="trinkets" label="Trinkets" selected={page === "trinkets"} />
        <NavTab page="pvp" label="PvP" selected={page === "pvp"} promo />
      </div>
    </div>
  );
};

const NavTab = (props) => {
  const { label, page, selected, disabled, promo } = props;
  const { changePage } = useWowPath();
  const newPathName = changePage(page);
  const queryParams = useQueryString();

  const search = useMemo(() => {
    if ("gameMode" in queryParams && page !== "pvp") {
      delete queryParams["gameMode"];
    }
    // The PvP page does not share any filters with the other pages
    if (page === "pvp") {
      for (let prop in queryParams) {
        if (queryParams.hasOwnProperty(prop) && prop !== "gameMode") {
          delete queryParams[prop];
        }
      }
    }

    return Object.keys(queryParams)
      .map((k) => `${k}=${queryParams[k]}`)
      .join("&");
  }, [queryParams]);

  if (disabled) {
    return (
      <div className="nav_tab disabled">
        {label}
        <div className="soon-box">
          SOON<span className="sup">&trade;</span>
        </div>
      </div>
    );
  }
  return (
    <NavLink
      to={{ pathname: newPathName, search }}
      className={classNames("nav_tab", {
        selected: selected,
      })}
    >
      {label} {promo ? <div className="new-box">NEW</div> : null}
    </NavLink>
  );
};

export default BuildsTabNav;
